const n = (s, ns = 'smm') => `new.${ns}.${s}`;

const smmStrings = {
  vk: {
    id: n('vk'),
    defaultMessage: 'ВКонтакте',
  },
  google: {
    id: n('google'),
    defaultMessage: 'Войти через Google',
  },
  facebook: {
    id: n('facebook'),
    defaultMessage: 'Facebook',
  },
  yandex: {
    id: n('yandex'),
    defaultMessage: 'Войти через Яндекс',
  },
};

export default smmStrings;
